import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSvg } from '../Svg';
import { chameleonTreeItem } from './TreeItem/TreeItem.definition';
import { chameleonTreeView } from './TreeView.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTreeView({ prefix }), chameleonTreeItem({ prefix }), chameleonSvg({ prefix }));
}
